var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightPurpleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25052 9.27852L15.742 9.27852L11.6152 13.4832C11.3798 13.7238 11.2475 14.0502 11.2475 14.3906C11.2475 14.7309 11.3798 15.0573 11.6152 15.298C11.8507 15.5386 12.1701 15.6738 12.5031 15.6738C12.8361 15.6738 13.1555 15.5386 13.391 15.298L19.6436 8.90789C19.7574 8.78635 19.8467 8.64303 19.9062 8.48615C20.0313 8.175 20.0313 7.826 19.9062 7.51485C19.8467 7.35798 19.7574 7.21465 19.6436 7.09311L13.391 0.703028C13.2747 0.583242 13.1364 0.488163 12.984 0.42328C12.8317 0.358397 12.6682 0.324992 12.5031 0.324992C12.338 0.324992 12.1746 0.358397 12.0222 0.42328C11.8698 0.488163 11.7315 0.583242 11.6152 0.703028C11.498 0.821837 11.405 0.963185 11.3415 1.11892C11.278 1.27466 11.2453 1.44171 11.2453 1.61042C11.2453 1.77913 11.278 1.94618 11.3415 2.10191C11.405 2.25765 11.498 2.399 11.6152 2.51781L15.742 6.72248L1.25052 6.72248C0.918864 6.72248 0.600789 6.85713 0.366271 7.09681C0.131753 7.33648 2.59188e-06 7.66155 2.56293e-06 8.0005C2.53397e-06 8.33945 0.131753 8.66452 0.366271 8.90419C0.600789 9.14387 0.918864 9.27852 1.25052 9.27852Z",
    fill: "#3C38CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPurpleArrow);
export default __webpack_public_path__ + "static/media/RightPurpleArrow.773b70f40877332a65da1b10bbaa1b3e.svg";
export { ForwardRef as ReactComponent };